import rootCategories from 'constants/categoryIds';

const buildOffersQueryParamFromId = id =>
  !id || Object.values(rootCategories).includes(id) ? null : `?categoryId=${id}`;

export default buildOffersQueryParamFromId;
